import React from 'react';
import StatusBadge from './StatusBadge';
import StatusRemarkHistory from './StatusRemarkHistory';
import { shouldShowInterviewDateForStatusEntry } from '../../utils/candidateStatus';
import { isLatestStatusEntry, sortStatusHistoryNewestFirst } from '../../utils/statusRemarks';
import { formatInterviewDate, formatStatusHistoryDate } from '../../utils/dateFormat';

function StatusHistorySection({
  candidate,
  candidateId,
  onRemarkAdded,
  layout = 'table',
  emptyMessage = 'No status updates available.',
}) {
  const statusHistory = Array.isArray(candidate?.Status) ? candidate.Status : [];
  const displayedHistory = sortStatusHistoryNewestFirst(statusHistory);
  const latestStatusEntryId = candidate?.latestStatusEntryId || '';

  if (!displayedHistory.length) {
    if (layout === 'block') {
      return <div>{emptyMessage}</div>;
    }

    return (
      <tr>
        <td colSpan={2}>{emptyMessage}</td>
      </tr>
    );
  }

  return displayedHistory.map((item, index) => {
    const entryKey = item._id || `status-${index}`;
    const canAddRemark = isLatestStatusEntry(item, statusHistory, latestStatusEntryId);
    const showInterviewDate = shouldShowInterviewDateForStatusEntry(item, candidate);

    if (layout === 'block') {
      return (
        <div key={entryKey} className="mb-3">
          <div>
            <b>Status:</b>{' '}
            <StatusBadge status={item.Status} useStoredLabel />
          </div>
          <div><b>Updated Date:</b> {formatStatusHistoryDate(item.Date)}</div>
          {showInterviewDate && (
            <div><b>Interview Scheduled:</b> {formatInterviewDate(candidate.interviewDate)}</div>
          )}
          <table className="table table-sm mb-0">
            <tbody>
              <StatusRemarkHistory
                candidateId={candidateId}
                statusEntry={item}
                onRemarkAdded={onRemarkAdded}
                canAddRemark={canAddRemark}
              />
            </tbody>
          </table>
          <hr />
        </div>
      );
    }

    return (
      <React.Fragment key={entryKey}>
        <tr>
          <td><b>Status :</b></td>
          <td><StatusBadge status={item.Status} useStoredLabel /></td>
        </tr>
        <tr>
          <td><b>Updated Date :</b></td>
          <td>{formatStatusHistoryDate(item.Date)}</td>
        </tr>
        {showInterviewDate && (
          <tr>
            <td><b>Interview Scheduled :</b></td>
            <td>{formatInterviewDate(candidate.interviewDate)}</td>
          </tr>
        )}
        <StatusRemarkHistory
          candidateId={candidateId}
          statusEntry={item}
          onRemarkAdded={onRemarkAdded}
          canAddRemark={canAddRemark}
        />
        <tr><td colSpan={2}><hr className="my-2" /></td></tr>
      </React.Fragment>
    );
  });
}

export default StatusHistorySection;
